import { Filters } from '../../_flux/constants/filter/filters';

const GA_EVENTS = {
    fittingStationFinder: {
        category: 'fitting_station_finder',
        actions: {
            initialOpen: 'initial_open',
            open: 'fitting_station_finder_open',
            close: 'fitting_station_finder_close',
            stationSelect: 'select_station'
        }
    },
    postcode: {
        category: 'postcode',
        actions: {
            entered: 'postcode_entered'
        }
    },
    friendbuy: {
        category: 'friendbuy',
        label: 'refer',
        actions: {
            startSharing: 'start_sharing',
            shareAgain: 'share_again',
            send: 'click_send',
            facebookShare: 'facebook_share',
            messengerShare: 'messenger_share',
            twitterShare: 'twitter_share',
        }
    },
    catalogConfigurator: {
        tyreSizeTitle: 'tyre_size_config',
        motoTyreSizeTitle: 'moto_tyre_size_config',
        actions: {
            open: 'configurator_open',
            close: 'configurator_close',
            goToFirstLayer: 'go_to_intro',
            goToForm: 'button_click_got_it',
            showInfo: 'click_on_more_info_link',
            setWidth: 'set_width',
            setHeight: 'set_profile',
            setDiameter: 'set_rim_size',
            setLoadIndex: 'set_load_index',
            setSpeedIndex: 'set_speed_index',
            setPostcode: 'set_postcode',
            noProductsFound: 'no_products_for_selected_filters',
            productsFoundAgain: 'products_found_with_altered_filters',
            showSizeConfiguratorLayer: 'show_size_configurator_layer',
            submit: 'view_tyre_sizes',
            showMeAllProducts: 'show_me_all_products',
        }
    },
    checkoutConfigurator: {
        category: 'checkout_vehicle_details',
        actions: {
            vehicleCheckoutLightboxShow: '1',
            selectState: '2',
            setRegistration: '3',
            continueClicked: '4',
            selectVehicleClicked: '5',
            alternativeLinkMakeModelYearClicked: '6',
            alternativeLinkSearchByVehicleClicked: '7',
            alternativeLinkSearchByRegoLookupClicked: '8',
            sorryICantProvideVehicleLinkClicked: '9',
            iCantProvideVehicleSubmitClicked: '10',
        }
    },
    vehicleSelector: {
        category: 'vehicle_selector',
        actions: {
            open: 'vehicle_selector_open',
            showVehicleNotProvidedLayer: 'show_vehicle_not_provided_layer',
            hideVehicleNotProvidedLayer: 'hide_vehicle_not_provided_layer',
            setVehicleNotProvidedComment: 'set_vehicle_not_provided_comment',
            close: 'vehicle_selector_close',
            setMake: 'set_make',
            setModel: 'set_model',
            setYear: 'set_year',
            setSeriesChassis: 'set_series_chassis',
            setEngine: 'set_engine',
            setDetails: 'set_details',
            setTyres: 'set_tyres',
            setPostcode: 'set_postcode',
            postcodeInvalid: 'vehicle_selector_postcode_invalid',
            showVehicleConfiguratorFromConfiguratorLayer: 'show_vehicle_configurator_from_configurator_layer',
            submit: 'view_tyre_sizes',
            showInfo: 'click_on_more_info_link',
            goToForm: 'button_click_got_it',
        }
    },
    regoLookup: {
        category: 'rego_lookup',
        actions: {
            open: 'rego_lookup_open',
            close: 'rego_lookup_close',
            setState: 'set_state',
            setVehicleNotProvidedComment: 'set_vehicle_not_provided_comment',
            setRego: 'set_registration',
            setPostcode: 'set_postcode',
            showConfirmationLayer: 'button_click_continue',
            hideConfirmationLayer: 'hide_confirmation_layer',
            showVehicleNotProvidedLayer: 'show_vehicle_not_provided_layer',
            hideVehicleNotProvidedLayer: 'hide_vehicle_not_provided_layer',
            postcodeInvalid: 'rego_lookup_postcode_invalid',
            registrationInvalid: 'rego_invalid',
            registrationNotFound: 'rego_not_found',
            showTyres: 'show_tyres',
            setTyres: 'set_tyres',
            showConfirmButton: 'show_confirm_button',
            showRegoFromConfiguratorLayer: 'show_rego_from_configurator_layer',
            submit: 'view_tyre_sizes',
            showInfo: 'click_on_more_info_link',
            goToForm: 'button_click_got_it',
        }
    },
    catalogFiltersDesktop: {
        category: 'catalog_filters_desktop',
        actions: {
            showToolTip: 'show_tooltip',
            openSection: 'open_filter',
            closeSection: 'close_filter',
            resetSectionFilters: 'reset_filter',
            setFilter: {
                [Filters.USAGE]: 'change_usage',
                [Filters.WIDTH]: 'change_width',
                [Filters.HEIGHT]: 'change_profile',
                [Filters.DIAMETER]: 'change_rim_size',
                [Filters.SPEED_INDEX]: 'change_speed_index',
                [Filters.LOAD_INDEX]: 'change_load_index',
                [Filters.MANUFACTURER]: 'change_brand',
                [Filters.PRODUCT_TYPE]: 'change_product_type',
                [Filters.MODEL]: 'change_model',
                [Filters.VEHICLE_TYPE]: 'change_vehicle_type',
                [Filters.RUN_FLAT]: 'change_run_flat',
                [Filters.BUY_4_PAY_3]: 'change_buy_4_pay_3',
                [Filters.CLEARANCE]: 'change_clearance',
                [Filters.INSTANT_CASH]: 'change_$100_cashback',
                [Filters.FREE_FITTING]: 'change_free_fitting',

                [Filters.DISCOUNT_INSTANT_CASH_50]: 'change_$50_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_80]: 'change_$80_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_100]: 'change_$100_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_120]: 'change_$120_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_150]: 'change_$150_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_160]: 'change_$160_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_200]: 'change_$200_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_300]: 'change_$300_cashback',
                [Filters.DISCOUNT_5_OFF]: 'change_5%_discount',
                [Filters.DISCOUNT_10_OFF]: 'change_10%_discount',
                [Filters.DISCOUNT_15_OFF]: 'change_15%_discount',
                [Filters.DISCOUNT_20_OFF]: 'change_20%_discount',

                [Filters.PRICE_MIN]: 'change_price_minimum',
                [Filters.PRICE_MAX]: 'change_price_maximum',
                [Filters.POSTCODE]: 'change_postcode',
                [Filters.REGISTRATION]: 'change_registration',
                [Filters.TECHNOLOGY]: 'change_technology',

                [Filters.UTQG_TREADWEAR_GROUP]: 'change_utqg_tradewear_group',
                [Filters.UTQG_TRACTION]: 'change_utqg_traction',
                [Filters.UTQG_TEMPERATURE]: 'change_utqg_temperature',

                [Filters.LABEL_NOISE]: 'change_label_noise',
                [Filters.LABEL_WET_GRIP]: 'change_label_wet_grip',
                [Filters.LABEL_FUEL_EFFICIENCY]: 'change_label_fuel_efficiency',

                [Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]: 'change_customer_review_dry_traction_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]: 'change_customer_review_low_noise_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]: 'change_customer_review_ride_comfort_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]: 'change_customer_review_steering_response_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]: 'change_customer_review_tread_wear_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]: 'change_customer_review_value_for_money_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]: 'change_customer_review_wet_traction_rating_avg_group',

                [Filters.QUALITY_SEGMENT_PREMIUM]: 'change_quality_segment_premium',
                [Filters.QUALITY_SEGMENT_VALUE]: 'change_quality_segment_value',
                [Filters.QUALITY_SEGMENT_BUDGET]: 'change_quality_segment_budget',

                [Filters.WHEEL_MODEL]: 'change_wheel_model',
                [Filters.WHEEL_DIAMETER]: 'change_wheel_diameter',
                [Filters.WHEEL_WIDTH]: 'change_wheel_width',
                [Filters.WHEEL_STUDS]: 'change_wheel_studs',
                [Filters.WHEEL_PCD]: 'change_wheel_pcd',
                [Filters.WHEEL_FINISH]: 'change_wheel_finish',
                [Filters.VEHICLE_MAKE]: 'change_vehicle_make',
                [Filters.VEHICLE_YEAR]: 'change_vehicle_year',
                [Filters.VEHICLE_SERIES_CHASSIS]: 'change_vehicle_series_chassis',
                [Filters.VEHICLE_MODEL]: 'change_vehicle_model',
                [Filters.VEHICLE_ENGINE]: 'change_vehicle_engine',
                [Filters.VEHICLE_DETAILS]: 'change_vehicle_details',
                [Filters.VEHICLE_TYRES]: 'change_vehicle_tyres',
                [Filters.VEHICLE_SERIES]: 'change_vehicle_series',
                [Filters.VEHICLE_CHASSIS]: 'change_vehicle_chassis',
                [Filters.VEHICLE_ENGINE_DETAILS]: 'change_vehicle_engine_details',
                [Filters.VEHICLE_YEAR_RANGE_FROM]: 'change_vehicle_year_range_from',
                [Filters.VEHICLE_YEAR_RANGE_TO]: 'change_vehicle_year_range_to',
                [Filters.VEHICLE_COUNTRY_OF_ORIGIN]: 'change_vehicle_country_of_origin',
                [Filters.VEHICLE_VIN]: 'change_vehicle_vin',
                [Filters.VEHICLE_ID]: 'change_vehicle_id',
                [Filters.VEHICLE_STATE]: 'change_vehicle_state',
            },
        }
    },
    catalogFiltersMobile: {
        category: 'catalog_filters_mobile',
        actions: {
            openMobileFilters: 'open_filter',
            closeMobileFilters: 'close_filter',
            saveSectionFilters: 'save_filters_in_section',
            resetSectionFilters: 'reset_filters_in_section',
            filterChange: {
                [Filters.USAGE]: 'change_usage',
                [Filters.WIDTH]: 'change_width',
                [Filters.HEIGHT]: 'change_profile',
                [Filters.DIAMETER]: 'change_rim_size',
                [Filters.SPEED_INDEX]: 'change_speed_index',
                [Filters.LOAD_INDEX]: 'change_load_index',
                [Filters.MANUFACTURER]: 'change_brand',
                [Filters.PRODUCT_TYPE]: 'change_product_type',
                [Filters.MODEL]: 'change_model',
                [Filters.VEHICLE_TYPE]: 'change_vehicle_type',
                [Filters.RUN_FLAT]: 'change_run_flat',
                [Filters.BUY_4_PAY_3]: 'change_buy_4_pay_3',
                [Filters.CLEARANCE]: 'change_clearance',
                [Filters.INSTANT_CASH]: 'change_$100_cashback',
                [Filters.FREE_FITTING]: 'change_free_fitting',

                [Filters.DISCOUNT_INSTANT_CASH_50]: 'change_$50_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_80]: 'change_$80_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_100]: 'change_$100_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_120]: 'change_$120_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_150]: 'change_$150_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_160]: 'change_$160_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_200]: 'change_$200_cashback',
                [Filters.DISCOUNT_INSTANT_CASH_300]: 'change_$300_cashback',
                [Filters.DISCOUNT_5_OFF]: 'change_5%_discount',
                [Filters.DISCOUNT_10_OFF]: 'change_10%_discount',
                [Filters.DISCOUNT_15_OFF]: 'change_15%_discount',
                [Filters.DISCOUNT_20_OFF]: 'change_20%_discount',

                [Filters.PRICE_MIN]: 'change_price_minimum',
                [Filters.PRICE_MAX]: 'change_price_maximum',
                [Filters.POSTCODE]: 'change_postcode',
                [Filters.REGISTRATION]: 'change_registration',
                [Filters.TECHNOLOGY]: 'change_technology',

                [Filters.UTQG_TREADWEAR_GROUP]: 'change_utqg_tradewear_group',
                [Filters.UTQG_TRACTION]: 'change_utqg_traction',
                [Filters.UTQG_TEMPERATURE]: 'change_utqg_temperature',

                [Filters.LABEL_NOISE]: 'change_label_noise',
                [Filters.LABEL_WET_GRIP]: 'change_label_wet_grip',
                [Filters.LABEL_FUEL_EFFICIENCY]: 'change_label_fuel_efficiency',

                [Filters.CUSTOMER_REVIEW_DRY_TRACTION_RATING_AVG_GROUP]: 'change_customer_review_dry_traction_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_LOW_NOISE_RATING_AVG_GROUP]: 'change_customer_review_low_noise_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_RIDE_COMFORT_RATING_AVG_GROUP]: 'change_customer_review_ride_comfort_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_STEERING_RESPONSE_RATING_AVG_GROUP]: 'change_customer_review_steering_response_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_TREAD_WEAR_RATING_AVG_GROUP]: 'change_customer_review_tread_wear_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_VALUE_FOR_MONEY_RATING_AVG_GROUP]: 'change_customer_review_value_for_money_rating_avg_group',
                [Filters.CUSTOMER_REVIEW_WET_TRACTION_RATING_AVG_GROUP]: 'change_customer_review_wet_traction_rating_avg_group',

                [Filters.QUALITY_SEGMENT_PREMIUM]: 'change_quality_segment_premium',
                [Filters.QUALITY_SEGMENT_VALUE]: 'change_quality_segment_value',
                [Filters.QUALITY_SEGMENT_BUDGET]: 'change_quality_segment_budget',

                [Filters.WHEEL_MODEL]: 'change_wheel_model',
                [Filters.WHEEL_DIAMETER]: 'change_wheel_diameter',
                [Filters.WHEEL_WIDTH]: 'change_wheel_width',
                [Filters.WHEEL_STUDS]: 'change_wheel_studs',
                [Filters.WHEEL_PCD]: 'change_wheel_pcd',
                [Filters.WHEEL_FINISH]: 'change_wheel_finish',
                [Filters.VEHICLE_MAKE]: 'change_vehicle_make',
                [Filters.VEHICLE_YEAR]: 'change_vehicle_year',
                [Filters.VEHICLE_SERIES_CHASSIS]: 'change_vehicle_series_chassis',
                [Filters.VEHICLE_MODEL]: 'change_vehicle_model',
                [Filters.VEHICLE_ENGINE]: 'change_vehicle_engine',
                [Filters.VEHICLE_DETAILS]: 'change_vehicle_details',
                [Filters.VEHICLE_TYRES]: 'change_vehicle_tyres',
                [Filters.VEHICLE_SERIES]: 'change_vehicle_series',
                [Filters.VEHICLE_CHASSIS]: 'change_vehicle_chassis',
                [Filters.VEHICLE_ENGINE_DETAILS]: 'change_vehicle_engine_details',
                [Filters.VEHICLE_YEAR_RANGE_FROM]: 'change_vehicle_year_range_from',
                [Filters.VEHICLE_YEAR_RANGE_TO]: 'change_vehicle_year_range_to',
                [Filters.VEHICLE_COUNTRY_OF_ORIGIN]: 'change_vehicle_country_of_origin',
                [Filters.VEHICLE_VIN]: 'change_vehicle_vin',
                [Filters.VEHICLE_ID]: 'change_vehicle_id',
                [Filters.VEHICLE_STATE]: 'change_vehicle_state',
            },
            unsetFilters: 'unset_filters',
            resetAllFiltersAndClose: 'reset_all_filters_and_close',
            applyFilters: 'apply_filters',
            openSection: 'open_section',
        }
    },
    catalogProductTile: {
        category: 'catalog_product_tile',
        actions: {
            openNotifyWhenRestockedLightbox: 'open_notify_me_when_restocked_lightbox',
            click: 'go_to_product_details'
        }
    },
    catalogProductAdTile: {
        category: 'sponsored_product',
        actions: {
            catalogView: 'sponsored_product_catalog_view',
            PDPView: 'sponsored_product_pdp_view',
            catalogClick: 'sponsored_product_catalog_click',
            catalogAddToCartClick: 'sponsored_product_catalog_add_to_cart_click',
            catalogViewDetailsClick: 'sponsored_product_catalog_view_details_click',
            click: 'go_to_product_details'
        }
    },
    ProductDetailAccordion: {
        category: 'pdp_accordion',
        actions: {
            click: 'click_on_pdp_accordion'
        }
    },
    catalogSorting: {
        category: 'catalog_sorting',
        actions: {
            changeSorting: 'change_sorting',
        }
    },
    catalogStatusbar: {
        category: 'catalog_statusbar',
        actions: {
            changeSpecific: 'change_specific_filters',
            addMissing: 'add_missing_filters',
        }
    },
    notifyMe: {
        category: 'notify_me',
        actions: {
            notifyWhenProductRestockedFormSubmit: 'when_product_restocked_submit',
            notifyWhenProductRestockedFormSubmitFailure: 'when_product_restocked_submit_failure',
        }
    },
    catalogNoResultSuggestion: {
        category: 'catalog_no_result_suggestion',
        actions: {
            improveFilter: {
                [Filters.PRICE_MIN]: 'improve_price_minimum_to',
                [Filters.PRICE_MAX]: 'improve_price_maximum_to',
            },
            removeFilter: {
                [Filters.WIDTH]: 'remove_width',
                [Filters.HEIGHT]: 'remove_profile',
                [Filters.DIAMETER]: 'remove_rim_size',
                [Filters.SPEED_INDEX]: 'remove_speed_index',
                [Filters.LOAD_INDEX]: 'remove_load_index',
                [Filters.MANUFACTURER]: 'remove_brand',
                [Filters.MODEL]: 'remove_model',
                [Filters.VEHICLE_TYPE]: 'remove_vehicle_type',
                [Filters.RUN_FLAT]: 'remove_run_flat',
                [Filters.BUY_4_PAY_3]: 'remove_buy_4_pay_3',
                [Filters.CLEARANCE]: 'remove_clearance',
                [Filters.INSTANT_CASH]: 'remove_$100_cashback',
                [Filters.POSTCODE]: 'remove_postcode',
            },
        }
    },
    wheelAlignmentInfoLightBox: {
        category: 'wheel_alignment_info_light_box',
        actions: {
            clickOnRemove: 'remove_service',
            clickOnOk: 'click_on_accept_and_continue',
            clickOnLearnMore: 'click_on_learn_more_link',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    selectFsInfoLightBox: {
        category: 'select_fitting_station_light_box',
        actions: {
            clickOnSelectMyTyreClick: 'click_on_select_my_tyre',
            clickOnContinueShopping: 'click_on_continue_shopping',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    fsRemoveInfoLightBox: {
        category: 'fitting_station_remove_light_box',
        actions: {
            clickOnRemove: 'remove_service',
            clickOnOk: 'click_on_accept_and_continue',
            clickOnLearnMore: 'click_on_learn_more_link',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    voucherCodeLightBox: {
        category: 'voucher_code_light_box',
        actions: {
            clickOnRedeem: 'redeem_voucher',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    crossSellRemoveInfoLightBox: {
        category: 'cross_sell_product_remove_light_box',
        actions: {
            clickOnRemove: 'remove_cross_sell_product',
            clickOnOk: 'click_on_keep_product',
            clickOnLearnMore: 'click_on_learn_more_link',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    crossSellInfoLightBox: {
        category: 'cross_sell_description_light_box',
        actions: {
            clickOnLearnMore: 'click_on_learn_more_link',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    vehicleDetailsInfoLightBox: {
        category: 'vehicle_details_description_light_box',
        actions: {
            clickOnLearnMore: 'click_on_learn_more_link',
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    vehiclePersonalisedPage: {
        category: 'vehicle_personalised_page',
        actions: {
            clickOnShowDetails: 'click_on_show_details',
            clickOnSeeAllAvailableVehicle: 'click_on_see_all_available_vehicle',
        }
    },
    driverReviewInfoLightBox: {
        category: 'driver_review_description_light_box',
        actions: {
            close: 'close_lightbox',
            open: 'open_lightbox',
        }
    },
    navigation: {
        category: 'navigation_v2',
        actions: {
            openMobile: 'open_mobile_navigation',
            closeMobile: 'close_mobile_navigation',
            openSecondLevel: 'open_second_level',
            backToFirstLevel: 'back_to_first_level',
            clickOnLevel1Link: 'click_on_level_1_link',
            clickOnLevel2Link: 'click_on_level_2_link',
            clickOnLevel3Link: 'click_on_level_3_link',
        },
    },
    whereToFindTyreSize: {
        category: 'where_to_find_tyre_size',
        actions: {
            open: 'open_lightbox',
            close: 'close_lightbox',
        },
    },
    customerRedirect: {
        category: 'customer_redirect',
        actions: {
            show: 'show_redirect_lightbox',
            close: 'close_redirect_lightbox',
            redirect: 'redirect_to_customer_country_site'
        }
    },
    servicesForm: {
        category: 'services_form',
        actions: {
            open: 'open_form',
            close: 'close_form',
            select: 'services_selected',
            deselect: 'services_deselected',
            next: 'next_to_page',
            previous: 'back_from_page',
            submit: 'services_form_submit'
        }
    },
    tyreSizeCalculator: {
        category: 'tyre_size_calculator',
        actions: {
            calculate: 'calculate',
            originalSize: 'original_size',
            newSize: 'new_size',
        }
    },
    geolocation: {
        category: 'geolocation',
        actions: {
            approved: 'geolocation_allowed',
            denied: 'geolocation_denied'
        }
    },
    timeSpent: {
        category: 'time_spent_10mins',
        actions: {
            time_spent_10mins: 'time_spent_more_than_10_minutes',
        }
    },
    freeFitting: {
        category: 'michelin_free_fitting_promotion',
        actions: {
            click: 'michelin_free_fitting_promotion',
        }
    },
    homePagePromo: {
        category: 'home_page_promo',
        actions: {
            homePage: 'homepage_promo',
        }
    },
    contactSupport: {
        category: 'contact_support_link',
        actions: {
            clickSendMailLink: 'click_on_send_email_link',
        },
    },
    openOrderTrackingPage: {
        category: 'open_order_tracking_page',
        actions: {
            clickOpenTrackingPageLink: 'click_on_tracking_page_link',
        },
    }
};

export default GA_EVENTS;
